import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateAreaSpecificationModificationArray } from "../../redux_store/jobState";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { blue } from "@material-ui/core/colors";
import Typography from "@material-ui/core/Typography";
import { toNumber } from "../../components/Common";
import { GetItems } from "../layout/PaperFunctions";

const styles = (theme) => ({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
});

export default withStyles(styles)(function SpecModifyDownpipeDialog(props) {
    const classes = makeStyles(styles);
    const dispatch = useDispatch();
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);

    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
        onClose();
    };

    const handleListItemClick = (value) => {
        let item = props.item;
        let position_text = "(0,0,0)";
        if (item.point) {
            let x = item.point.x;
            let y = item.point.y;
            if (window.paper_origin) {
                x = x - window.paper_origin.x;
                y = -(y - window.paper_origin.y);
            }

            position_text = "(" + x.toFixed(0) + "," + y.toFixed(0) + ",0)";
        } else if (item.post_data) {
            position_text = item.post_data.ref.replaceAll("/", ",");
        } else if (item.ref) {
            position_text = item.ref.replaceAll("/", ",");
            if (position_text.split("/").length === 2) position_text.replace(")", ",0)");
        }

        let downpipe = {
            Ref: position_text,
            Position: position_text,
            Kind: value,
        };
        dispatch(
            updateAreaSpecificationModificationArray(
                item.areaIndex,
                "GUTTERS_AND_DOWNPIPES.Downpipes",
                position_text,
                null,
                downpipe
            )
        );
        onClose();
    };

    let roof_area = 0;
    for (let area of AreaSpecifications) {
        if (area?.META?.RoofArea) roof_area += toNumber(area?.META?.RoofArea);
    }
    let origin = GetItems({ typeQQ: "origin" });
    if (origin && origin[0] && origin[0]?.roof_areas && origin[0]?.roof_areas.split) {
        let roof_areas = origin[0]?.roof_areas.split("/");
        roof_area = 0;
        for (let area of roof_areas) {
            roof_area += toNumber(area);
        }
    }

    let recommended = Math.ceil((roof_area - 1) / 50);

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">Choose Downpipe Type</DialogTitle>
            <Typography
                variant="overline"
                display="block"
                gutterBottom
                style={{
                    lineHeight: "1rem",
                    padding: "0px 30px",
                    textAlign: "center",
                }}
            >
                Roof Area: {roof_area.toFixed(1)}m2
                <br />
                One downpipe required for every 50m2 of catchment
                <br />
                {recommended} Downpipe recommended
            </Typography>
            <List>
                <ListItem button onClick={() => handleListItemClick("Ground - Connection by Owner")}>
                    <ListItemText primary={"Ground - Connection by Owner"} />
                </ListItem>
                <ListItem autoFocus button onClick={() => handleListItemClick("Offset Under Eave")}>
                    <ListItemText primary="Offset Under Eave" />
                </ListItem>
                <ListItem autoFocus button onClick={() => handleListItemClick("Stormwater")}>
                    <ListItemText primary="Stormwater" />
                </ListItem>
                <ListItem autoFocus button onClick={() => handleListItemClick("Rubble Pit")}>
                    <ListItemText primary="Rubble Pit" />
                </ListItem>
                <ListItem autoFocus button onClick={() => handleListItemClick("Pre Lay Stormwater")}>
                    <ListItemText primary="Pre Lay Stormwater" />
                </ListItem>
                <ListItem autoFocus button onClick={() => handleListItemClick("Aerial Connection")}>
                    <ListItemText primary="Aerial Connection" />
                </ListItem>
            </List>
        </Dialog>
    );
});
